export default {
	qita: 'Others',
	chengjirenyixuanze: 'The passenger has already selected, cannot choose again',
	dingdanzhuangtai: 'Order Status',
	daifukuan: 'Pending payment',
	daichupiao: 'Pending ticket issuance',
	chupiaowancheng: 'Ticket issuance completed',
	quxiao: 'Cancel',
	yinhangka: 'Bank Card',
	dianziqianbao: 'Electronic Wallet',
	yiwancheng: 'Completed',
	weiwancheng: 'Not Completed',
	quxiaozhong: 'Canceling',
	zhifuzhong: 'In Payment',
	chongxinxuanzezhifufangshi: 'Choose a new payment method',
	zhifuweiwancheng: 'Payment not completed',
	jixuzhifu: 'Continue payment',
	chongxingoumai: 'Repurchase',
	ninhaiweiwanchengzhifu: 'You have not completed the payment yet. Do you want to continue with the payment?',
	quebaoziliao: 'Please ensure all the details are correct.',
	lianluorenziliao: 'Contact Person Details',
	dianhuahaoma: 'Phone Number',
	fujiafuwu: 'Add On',
	feixingchangkehaoma: 'Frequent Flyer Number',
	dianziyouhuiquan: 'eCoupon',
	meiyoudianziyouhui: "Don't apply eCoupon",
	wodedaima: 'I have a Code',
	jiayiri: 'day',
	jiaerri: 'days',
	xianzaifukuan: 'Pay Now',
	zhifuwancheng: 'Payment Completed',
	yudaowenti: 'Encountering Problems',
	qingninzaixindakaideyemian: 'Please make the payment on the newly opened page!',
	zhifuwanchengqianqingbuyao: 'Please do not close this window until payment is completed',
	cuowuyuanyin: 'Error reason',
	zhifucuowu: 'Payment Error',
	bizhongbuzhichi: 'The currency is not supported',
	jinechaochuxianzhi: 'Amount exceeds limit',
	querenzhifu: 'Confirm payment',
	xiugai: 'Edit',
	xiangqing: 'Details',
	chengke: 'Passenger',
	daililianluoziliao: 'Agency Contact Details',
	banlidengji: 'Check-In',
	chakanguanli: 'View/Manage',
	chufa: 'Departure',
	riqishijian: 'Date/Time',
	yudingcankaobianhao: 'Booking Reference',
	chengshijichang: 'City/Airport',
	dao: 'To',
	daoda: 'Arrival',
	daodashijian: 'Arrival Time',
	xingcheng: 'Itinerary',
	lieyin: 'Print',
	shuikuanfapiao: 'Tax Invoice',
	genggaihangbanyaoqiu: 'Flight Change Requirements',
	lvxingshijian: 'Travel Time',
	xinglie: 'Checked Bag',
	nian: ' Year',
	yue: ' Month',
	geshibuzhengque: ' Format Error',
	lianxirenxingming: ' Contact Name',
	tuipiao: 'Refund Ticket',
	gaiqian: 'Rebook',
	querenyaotuipiaoma: 'Are you sure you want to refund the ticket?',
	querenyaogaiqianma: 'Are you sure you want to change the signature?',
	pingtaifuwufei: 'Platform Service Fee',
	xuzhifu: 'Price You Pay',
	jishufuwufei: 'Technical Service Fee',
	canshucuowu: 'Parameter Error',
	chupiaoshibaichongxinyuding: 'Issue Failed and Refund Success! Please try to rebook!',
	chupiaoshibaibufentuikuanchenggong: 'Issue Failed and Refund Partial Success! If you have any questions, plese contact customer service.',
	chupiaoshibaituikuanshibai: 'Issue Ticket Failed and Refund Failed! Please contact customer service for assistance!',
	dingdanzhuangtaiyichang: 'Order Status Abnormal',
	shouxufei: 'Commission',
	xinglixinxi: 'Baggage information',
	xingli: 'Baggage',
	dingdanxinxi: 'Order Information',
	dingdantijiaochenggong: 'Order Submitted Successfully',
	qingzhifu: 'Please pay within 30 minutes, or the order will be canceled.',
	kezailiebiaochakan: 'You can view my “orders“ in the order list',
	chakandingdan: 'View Order',
	ri: 'Day',
	yiyue: 'January',
	eryue: 'February',
	sanyue: 'March',
	siyue: 'April',
	wuyue: 'May',
	liuyue: 'June',
	qiyue: 'July',
	bayue: 'August',
	jiuyue: 'September',
	shiyue: 'October',
	shiyiyue: 'November',
	shieryue: 'December',
	xuanzefukuanfangshi: 'Select Payment Method',
	qingyu: 'Please complete the payment before',
	neiwanchengzhifu: ' ',
	kaxinxi: 'Card Information',
	xinyongkahao: 'Credit card number',
	xinyongkayouxiaoqi: 'Credit card expiration date',
	chikarenxingshi: "Last name",
	chikarenmingzi: "Given names",
	youxiang: 'Email',
	dianhua: 'Telephone',
	shengfendiqu: 'Province/Region',
	chengshi: 'City/Urban area',
	youbian: 'Postal code',
	jiedaodizhi: 'Street address',
	zhangdanxinxi: 'Billing Information',
	dingdanbianhao: 'Order Number:',
	dingdanbizhong: 'Order Currency:',
	dingdanjine: 'Order Amount:',
	guojia: 'Country',
	zhuan: 'Turn',
	ci: 'Time',
	fen: 'm',
	miao: 's',
};
